import { Room } from 'matrix-js-sdk/src';
import moment from 'moment';

import { getRoomInformationFromIdentityServerById } from 'api/identityService/getRoomInformationFromIdentityServerById';
import { CUSTOM_MEEDIO_EVENTS, isValidRoomSecretEvent } from 'utils/matrixUtils';

import { MINUTES_IN_UNIT } from '../AutoRemindersStepModal/utils';
import { Reminder } from '../CreateNewRoomDataProvider/utils';

export type CreateRoomProps = {
  roomName: string;
  isWaitingListEnabled: boolean;
  participants: string[];
  invitationMessage?: string;
  startsAt?: string | null;
  endsAt?: string | null;
  roomAlias?: string;
  description?: string;
};

export type UpdateRoomProps = CreateRoomProps & { room: Room };

export const getFullDateAt = (date: Date, time: Date, timeZone?: number) => {
  const timeMoment = moment(time);
  let combined = moment(date).set({ hour: timeMoment.hour(), minute: timeMoment.minute() });

  if (typeof timeZone === 'number') combined = combined.utcOffset(timeZone * 60, true);

  return combined.format('YYYY-MM-DD[T]HH:mm:ss.SSSZ');
};

export const getRoomSecret = (room: Room) => {
  const data = room.getAccountData(CUSTOM_MEEDIO_EVENTS.ROOM_SECRET);
  const content = data?.getContent();

  if (!isValidRoomSecretEvent(content)) throw new Error('Invalid room secret event');

  return content.roomSecret;
};

export const getInviteInformation = async (room: Room) => {
  const roomSecret = getRoomSecret(room);

  return getRoomInformationFromIdentityServerById(room.roomId, roomSecret);
};

export const getActiveRemindersIsoFormat = (reminders: Reminder[], eventStart: string) => {
  const activeReminders = reminders.filter(({ enabled }) => enabled);
  if (!activeReminders.length) return [];

  const eventStartParsed = moment.parseZone(eventStart);

  return activeReminders.map((reminder) => {
    const offsetMinutes = (reminder.amount || 0) * MINUTES_IN_UNIT[reminder.unit];
    const reminderMoment = eventStartParsed.clone().subtract(offsetMinutes, 'minutes');

    return reminderMoment.toISOString(true);
  });
};

export const generateSecret = (bytes = 32) => {
  const buf = new Uint8Array(bytes);
  window.crypto.getRandomValues(buf);

  return Array.from(buf)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};
